import { Grid } from '@mui/material'
import Typography from '@mui/material/Typography'
import React, { ReactElement } from 'react'
import { useAsyncFetch } from 'react-hooks-async-handlers'
import { useDispatch } from 'react-redux'
import { RendererStatusSplit } from 'react-renderer-status-split'
import Loader from './components/Loader'
import FormDispatcher from './reducers/form/dispatcher'
import { ReduxDispatch } from './typings/ReduxDispatch'

interface Props {
  children: ReactElement
}

function AppSetup(props: Props) {
  const { children } = props

  const dispatch = useDispatch<ReduxDispatch>()
  const installAction = useAsyncFetch(async () => {
    await dispatch(FormDispatcher.install())
  })

  return (
    <RendererStatusSplit
      statuses={installAction}
      renderPreview={() => null}
      renderError={(error) => <Typography color={'error'}>{error}</Typography>}
      renderLoading={() => (
        <Grid container justifyContent={'center'}>
          <Loader />
        </Grid>
      )}
      render={() => children}
    />
  )
}

export default AppSetup
